import styled, { css, keyframes } from 'styled-components';

import { styledReset } from '@pkg/primitives';

import { tokens } from './tokens';

const loadingKeyFrames = keyframes`
    0% { opacity: .2 }
    50% { opacity: .1 }
    100% { opacity: .2 }
`;

export const StyledFloorActivity = styled.div<{ $isLoading?: boolean }>`
    ${styledReset.borderBox};
    z-index: ${tokens.zindex.base};
    position: relative;
    display: grid;

    ${({ $isLoading }) =>
        $isLoading &&
        css`
            &:before {
                content: '';
                width: 100%;
                height: 100%;
                background: grey;
                z-index: ${tokens.zindex.base + 4};
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 15px;
                animation: ${loadingKeyFrames} 1s ease-in-out infinite;
            }
            div {
                opacity: 0;
            }
        `}
`;
